module.exports = "data:image/gif;base64,R0lGODlhBwAHAIAAALmGL/bt3SH5BAAAAAAALAAAAAAHAAcAAAIJjI9poMD4lDQFADs="


//////////////////
// WEBPACK FOOTER
// ./src/images/newslist.gif
// module id = v6AV
// module chunks = 1